import BigNumber from 'bignumber.js';
import { AbiItem, isAddress } from 'web3-utils';

import { ContractsManager, isValidAbi } from 'modules/core';
import { api, cacheTags } from 'modules/store';

interface GetEstimateGasParams {
  currentAccount: string;
  contractAddress: string;
  functionName: string;
  params: unknown[];
  abi: AbiItem[];
}

export const {
  useGetGasLimitQuery,
  endpoints: { getGasLimit },
} = api.injectEndpoints({
  endpoints: build => ({
    getGasLimit: build.query<BigNumber | null, GetEstimateGasParams>({
      queryFn: async ({
        abi,
        currentAccount,
        contractAddress,
        functionName,
        params,
      }) => {
        const isValidData =
          !!currentAccount &&
          isAddress(contractAddress) &&
          !!functionName &&
          isValidAbi(abi);
        if (!isValidData) {
          return { data: null };
        }

        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cant_define_property_object_not_extensible
        const copiedAbi = JSON.parse(JSON.stringify(abi));
        Object.preventExtensions(copiedAbi);

        const instance = await ContractsManager.getInstance();
        const contract = await instance.getCustomContract(
          contractAddress,
          copiedAbi,
        );

        try {
          const { gasLimit } = await instance.getGasInfo({
            currentAccount,
            contract,
            method: functionName,
            args: params,
          });
          return {
            data: gasLimit,
          };
        } catch {
          return { data: null };
        }
      },
      providesTags: [cacheTags.taskData],
    }),
  }),
});
